<template>
    <div class="resource-container">
        <!-- 搜索区域 -->
        <el-card class="search-wrapper">
            <el-form
                :inline="true"
                :model="queryParams"
                class="demo-form-inline"
            >
                <el-form-item label="产品名称">
                    <el-input
                        v-model="queryParams.goodsName"
                        placeholder="请输入产品名称"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="产品分类">
                    <el-select
                        v-model="queryParams.goodsCategory"
                        placeholder="请选择分类"
                        clearable
                    >
                        <el-option v-for="(item,index) in goodsCategoryOptions" :key="index" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="库存状态">
                    <el-select
                        v-model="queryParams.inventoryStatus"
                        placeholder="请选择状态"
                        clearable
                    >
                        <el-option v-for="(item,index) in inventoryStatusOptions" :key="index" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="地区">
                    <el-select
                        v-model="queryParams.region"
                        placeholder="请选择分类"
                        clearable
                    >
                        <el-option v-for="(item,index) in regionOptions" :key="index" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="上架状态">
                    <el-select
                        v-model="queryParams.goodsStatus"
                        placeholder="请选择状态"
                        clearable
                    >
                        <el-option label="已上架" value="1" />
                        <el-option label="已下架" value="0" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleQuery"
                        >查询</el-button
                    >
                    <el-button @click="resetQuery">重置</el-button>
                </el-form-item>
            </el-form>
            <el-row :gutter="10" class="mb8">
                <el-col :span="1.5">
                    <el-button type="primary" @click="handleAdd"
                        >新增</el-button
                    >
                </el-col>
                <el-col :span="1.5">
                    <el-button type="success" @click="openUploadDialog"
                        >导入</el-button
                    >
                </el-col>
                <el-col :span="1.5">
                    <el-button type="warning" @click="handleExport"
                        >导出</el-button
                    >
                </el-col>
                <el-col :span="1.5">
                    <el-button type="primary" plain @click="handleBatchOnline"
                        >批量上架</el-button
                    >
                </el-col>
                <el-col :span="1.5">
                    <el-button type="danger" @click="handleBatchOffline"
                        >批量下架</el-button
                    >
                </el-col>
                <el-col :span="1.5">
                    <el-button type="danger" plain @click="handleBatchDelete"
                        >批量删除</el-button
                    >
                </el-col>
            </el-row>
        </el-card>

        <!-- 表格区域 -->
        <el-card class="table-wrapper">
            <el-table
                border
                v-loading="loading"
                :data="resourceList"
                @selection-change="handleSelectionChange"
                :reserve-selection="true"
                row-key="id"
                ref="table"
            >
                <el-table-column type="selection" width="50" align="center" />
                <el-table-column
                    label="序号"
                    type="index"
                    width="50"
                    align="center"
                />
                <el-table-column label="产品名称" prop="goodsName" align="center" />
                <el-table-column
                    label="产品分类"
                    prop="goodsCategory"
                    align="center"
                >
                    <template #default="scope">
                        {{ goodsCategoryOptions.find(item => item.value === scope.row.goodsCategory)?.label || scope.row.goodsCategory }}
                    </template>
                </el-table-column>
                <el-table-column label="产品计费" prop="billingMethod" align="center">
                    <!-- <template #default="scope">
                        ¥{{ scope.row.billingMethod }} /卡/小时
                    </template> -->
                </el-table-column>
                </el-table-column>
                <el-table-column
                    label="库存状态"
                    prop="inventoryStatus"
                    align="center"
                >
                    <template #default="scope">
                        {{ inventoryStatusOptions.find(item => item.value === scope.row.inventoryStatus)?.label || scope.row.goodsCategory }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="咨询方式"
                    prop="consultationMethod"
                    align="center"
                >
                </el-table-column>
                <el-table-column label="地区" prop="region" align="center">
                     <template #default="scope">
                        {{ regionOptions.find(item => item.value === scope.row.region)?.label || scope.row.goodsCategory }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="上架状态"
                    prop="goodsStatus"
                    align="center"
                >
                    <template #default="scope">
                        <span
                            :class="
                                scope.row.goodsStatus == '0'
                                    ? 'goodsStatus_1'
                                    : 'goodsStatus_2'
                            "
                        >
                            {{
                                scope.row.goodsStatus == "1" ? "已上架" : "已下架"
                            }}
                        </span>
                        <div v-show="scope.row.goodsStatus == '1'">{{scope.row.listingTime}}</div>
                        <div v-show="scope.row.goodsStatus == '0'">{{scope.row.delistingTime}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="220">
                    <template #default="scope">
                        <el-button type="text" @click="handleEdit(scope.row)" v-if="scope.row.goodsStatus == 0"
                            >编辑</el-button
                        >
                        <el-button
                            type="text"
                            @click="handleStatusChange(scope.row)"
                        >
                            {{ scope.row.goodsStatus === 1 ? "下架" : "上架" }}
                        </el-button>
                        <el-button
                            type="text"
                            @click="handleNcnpSync(scope.row)"
                        >
                            <span :class="ncnpClass(scope.row.ncnpSyncStatus)">
                                {{ ncnpStatusText(scope.row.ncnpSyncStatus) }}
                            </span>
                        </el-button>
                        <el-button
                            type="text"
                            style="color: #F56C6C;"
                            @click="handleDelete(scope.row)"
                            v-if="scope.row.goodsStatus == 0"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination
                    v-model:current-page="queryParams.current"
                    v-model:page-size="queryParams.size"
                    :page-sizes="[10, 20, 50, 100]"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                />
            </div>
        </el-card>

        <!-- 新增/编辑弹框 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="700px"
            append-to-body
            :before-close="handleClose"
        >
            <el-form
                ref="formRef"
                :model="form"
                :rules="rules"
                label-width="100px"
            >
                <el-form-item label="产品名称" prop="goodsName">
                    <el-input
                        v-model="form.goodsName"
                        placeholder="请输入产品名称"
                    />
                </el-form-item>
                <el-form-item label="产品简介" prop="goodsDescription">
                    <el-input
                        v-model="form.goodsDescription"
                        type="textarea"
                        autosize
                        placeholder="请输入产品简介"
                    />
                </el-form-item>
                <el-form-item label="产品分类" prop="goodsCategory">
                    <el-select
                        v-model="form.goodsCategory"
                        placeholder="请选择分类"
                        style="width: 100%"
                    >
                        <el-option label="智算" :value="1" />
                        <el-option label="超算" :value="2" />
                        <el-option label="通算" :value="3" />
                        <el-option label="量算" :value="4" />
                    </el-select>
                </el-form-item>
                <el-form-item label="产品计费" prop="billingMethod">
                    <el-input
                        v-model="form.billingMethod"
                        placeholder="请输入产品计费"
                    />
                    <!-- <el-input-number
                        v-model="form.billingMethod"
                        :min="0"
                        :precision="2"
                        :step="0.1"
                        placeholder="请输入产品计费"
                    />
                    <span class="unit">卡/小时</span> -->
                </el-form-item>
                <el-form-item label="库存状态" prop="inventoryStatus">
                    <el-select
                        v-model="form.inventoryStatus"
                        placeholder="请选择库存状态"
                        style="width: 100%"
                    >
                        <el-option label="充足" :value="1" />
                        <el-option label="紧张" :value="2" />
                    </el-select>
                </el-form-item>
                <el-form-item label="地区" prop="region">
                    <el-select
                        v-model="form.region"
                        placeholder="请选择地区"
                        style="width: 100%"
                    >
                        <el-option label="安徽" :value="4" />
                        <el-option label="上海" :value="1" />
                        <el-option label="江苏" :value="2" />
                        <el-option label="浙江" :value="3" />
                    </el-select>
                </el-form-item>
                <el-form-item label="咨询方式" prop="consultationMethod">
                    <el-input
                        v-model="form.consultationMethod"
                        placeholder="请输入咨询方式"
                    />
                </el-form-item>
                <el-form-item label="订购链接" prop="subscriptionLink">
                    <el-input
                        v-model="form.subscriptionLink"
                        placeholder="请输入订购链接"
                    />
                </el-form-item>
                <el-form-item label="详情链接" prop="externalLinkDetail">
                    <el-input
                        v-model="form.externalLinkDetail"
                        placeholder="国家平台商品详情链接"
                    />
                </el-form-item>
                <el-form-item label="购买链接" prop="externalLinkAccess">
                    <el-input
                        v-model="form.externalLinkAccess"
                        placeholder="国家平台商品购买链接"
                    />
                </el-form-item>
                <el-form-item label="控制台链接" prop="externalLinkConsole">
                    <el-input
                        v-model="form.externalLinkConsole"
                        placeholder="国家平台使用控制台链接"
                    />
                </el-form-item>
                <el-form-item label="国家平台分类编码" prop="ncnpCategoryCode">
                    <el-input
                        v-model="form.ncnpCategoryCode"
                        placeholder="国家平台商品分类编码"
                    />
                </el-form-item>
                <el-form-item label="国家平台分类名称" prop="ncnpCategoryName">
                    <el-input
                        v-model="form.ncnpCategoryName"
                        placeholder="国家平台商品分类名称"
                    />
                </el-form-item>
                <el-form-item label="上架状态" prop="goodsStatus">
                    <el-select
                        v-model="form.goodsStatus"
                        placeholder="请选择上架状态"
                        style="width: 100%"
                    >
                        <el-option label="上架" :value="1" />
                        <el-option label="下架" :value="0" />
                    </el-select>
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button type="primary" @click="submitForm"
                        >确 定</el-button
                    >
                </span>
            </template>
        </el-dialog>

    <el-dialog
      title="导入"
      :visible.sync="uploadDialogVisible"
      width="35%"
      :close-on-click-modal="false"
    >
      <upload-dom
        v-if="uploadDialogVisible"
        ref="uploadDomRef"
        url="/blade-system/goods/import-goods"
        fileTemplateName="算力资源信息填报模板"
        @uploadSuccess="uploadSuccess"
      ></upload-dom>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeUpload">关 闭</el-button>
        <el-button type="primary" @click="submitUpload" v-if="!isUploadSuccess">导 入</el-button>
      </span>
    </el-dialog>
    </div>
</template>

<script>
import {
  goodsPage,
  goodsSave,
  goodsUpdate,
  goodsRemove,
  goodsBatchStatus,
  exportBlob,
} from "@/api/admin";
import { ncnpGoodsSync, ncnpGoodsRetry } from "@/api/index";
import uploadDom from "@/components/UploadXlsx.vue";
import dict from "@/utils/dict";
import { getCurrentTime, downloadXls } from "@/utils/index.js";
export default {
  name: "ComputeResource",
  components: {
    uploadDom,
  },
  data() {
    return {
      goodsCategoryOptions: dict.goodsCategoryOptions,
      inventoryStatusOptions: dict.inventoryStatusOptions,
      regionOptions: dict.regionOptions,
      // 导入弹框
      uploadDialogVisible: false,
      isUploadSuccess: false,

      // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 所有选中行数据
      selectedRows: [],
      // 总条数
      total: 0,
      // 资源列表
      resourceList: [],
      // 查询参数
      queryParams: {
        current: 1,
        size: 10,
        name: undefined,
        category: undefined,
        status: undefined,
      },

      //弹框类型
      dialogType: "",
      // 弹框标题
      dialogTitle: "",
      // 弹框显示状态
      dialogVisible: false,
      // 表单对象
      form: {
        id: undefined,
        goodsName: "",
        goodsDescription: "",
        goodsCategory: undefined,
        billingMethod: "",
        inventoryStatus: undefined,
        region: undefined,
        consultationMethod: "",
        subscriptionLink: "",
        externalLinkDetail: "",
        externalLinkAccess: "",
        externalLinkConsole: "",
        ncnpCategoryCode: "",
        ncnpCategoryName: "",
        goodsStatus: undefined,
      },
      // 表单校验规则
      rules: {
        goodsName: [
          {
            required: true,
            message: "请输入产品名称",
            trigger: "blur",
          },
        ],
        goodsDescription: [
          {
            required: true,
            message: "请输入产品简介",
            trigger: "blur",
          },
        ],
        goodsCategory: [
          {
            required: true,
            message: "请选择产品分类",
            trigger: "change",
          },
        ],
        billingMethod: [
          {
            required: true,
            message: "请输入产品计费",
            trigger: "blur",
          },
        ],
        inventoryStatus: [
          {
            required: true,
            message: "请选择库存状态",
            trigger: "change",
          },
        ],
        region: [
          {
            required: true,
            message: "请选择地区",
            trigger: "change",
          },
        ],
        consultationMethod: [
          {
            required: true,
            message: "请输入咨询方式",
            trigger: "blur",
          },
        ],
        subscriptionLink: [
          {
            required: true,
            message: "请输入订购链接",
            trigger: "blur",
          },
        ],
        goodsStatus: [
          {
            required: true,
            message: "请选择上架状态",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //关闭上传
    closeUpload() {
      this.$refs.uploadDomRef.handleClear();
      this.uploadDialogVisible = false;
      this.isUploadSuccess = false;
    },
    //打开上传
    openUploadDialog() {
      this.uploadDialogVisible = true;
    },
    //上传成功
    uploadSuccess() {
      this.isUploadSuccess = true;
      this.getList();
    },
    //提交上传
    submitUpload() {
      this.$refs.uploadDomRef.submitUpload();
    },
    /** 查询资源列表 */
    getList() {
      this.loading = true;
      // TODO: 调用接口获取数据
      goodsPage(this.queryParams)
        .then((res) => {
          if (res.code === 200) {
            this.resourceList = res.data.records;
            this.total = res.data.total;
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.current = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        current: 1,
        size: 10,
        name: undefined,
        category: undefined,
        status: undefined,
      };
      this.handleQuery();
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.dialogType = "add";
      this.dialogTitle = "新增产品";
      this.dialogVisible = true;
      this.resetForm();
    },
    /** 编辑按钮操作 */
    handleEdit(row) {
      this.dialogType = "edit";
      this.dialogTitle = "编辑产品";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.form = { ...row };
      });
    },
    /** 重置表单 */
    resetForm() {
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
      this.form = {
        id: undefined,
        goodsName: "",
        goodsDescription: "",
        goodsCategory: undefined,
        billingMethod: "",
        inventoryStatus: undefined,
        region: undefined,
        consultationMethod: "",
        subscriptionLink: "",
        goodsStatus: "",
      };
    },
    handleClose() {
      this.dialogVisible = false;
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
    },
    /** 提交表单 */
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          // TODO: 调用新增或编辑接口
          if (this.dialogType === "add") {
            goodsSave(this.form).then((res) => {
              if (res.code === 200) {
                this.$message.success("新增成功");
                this.dialogVisible = false;
                this.getList();
              }
            });
          } else {
            goodsUpdate(this.form).then((res) => {
              if (res.code === 200) {
                this.$message.success("编辑成功");
                this.dialogVisible = false;
                this.getList();
              }
            });
          }

          // this.dialogVisible = false;
          // this.getList();
        }
      });
    },
    /** 导入按钮操作 */
    handleImport() {
      // TODO: 实现导入逻辑
      this.$message.success("导入操作");
    },
    /** 导出按钮操作 */
    handleExport() {
      // 获取选中的数据ID
      const selectedIds = this.selectedRows.map(row => row.id);
      const hasSelected = selectedIds.length > 0;
      
      // 确认提示文本
      const confirmText = hasSelected 
        ? `是否导出已选择的 ${selectedIds.length} 条算力资源数据?` 
        : "是否导出全部算力资源数据?";
        
      this.$confirm(confirmText, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        // 构建导出URL，如果有选中数据则添加ids参数
        let exportUrl = "/blade-system/goods/export-goods";
        if (hasSelected) {
          exportUrl += `?ids=${selectedIds.join(",")}`;
        }
        
        // 调用导出接口
        exportBlob(exportUrl).then((res) => {
          // 文件名称：选中导出或全部导出
          const fileName = hasSelected 
            ? `已选择的算力资源数据${getCurrentTime()}.xlsx` 
            : `全部算力资源数据${getCurrentTime()}.xlsx`;
            
          downloadXls(res, fileName);
          
          // 导出成功提示
          this.$message.success(hasSelected ? "已选数据导出成功" : "全部数据导出成功");
        }).catch(() => {
          this.$message.error("导出失败");
        });
      });
    },
    /** 批量上架按钮操作 */
    handleBatchOnline() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请选择要上架的数据");
        return;
      }

      // 检查是否所有选中的数据都是下架状态
      // const hasOnlineData = this.selectedRows.some(
      //     (row) => row.goodsStatus == "1"
      // );
      // if (hasOnlineData) {
      //     this.$message.warning(
      //         "选中的数据中包含已上架的数据，请重新选择"
      //     );
      //     return;
      // }

      this.$confirm("确认要批量上架选中的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // TODO: 调用批量上架接口
          const ids = this.selectedRows.map((row) => row.id);
          goodsBatchStatus({ ids, goodsStatus: 1 }).then((res) => {
            if (res.code === 200) {
              this.$message.success("批量上架成功");
              this.getList();
            }
          });
          this.getList();
        })
        .catch(() => {
          // this.$message.info("已取消批量上架操作");
        });
    },
    /** 批量下架按钮操作 */
    handleBatchOffline() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请选择要下架的数据");
        return;
      }

      // 检查是否所有选中的数据都是上架状态
      const hasOfflineData = this.selectedRows.some(
        (row) => row.goodsStatus == "0"
      );
      // if (hasOfflineData) {
      //     this.$message.warning(
      //         "选中的数据中包含已下架的数据，请重新选择"
      //     );
      //     return;
      // }

      this.$confirm("确认要批量下架选中的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // TODO: 调用批量下架接口
          const ids = this.selectedRows.map((row) => row.id);
          goodsBatchStatus({ ids: ids.join(), goodsStatus: 0 }).then((res) => {
            if (res.code === 200) {
              this.$message.success("批量下架成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          // this.$message.info("已取消批量下架操作");
        });
    },
    /** 表格多选框选中数据 */
    handleSelectionChange(selection) {
      // 更新当前页选中的数据
      const currentPageIds = selection.map((item) => item.id);

      // 从selectedRows中移除当前页取消选中的数据
      this.selectedRows = this.selectedRows.filter((row) => {
        const isInCurrentPage = this.resourceList.some(
          (item) => item.id === row.id
        );
        return !isInCurrentPage || currentPageIds.includes(row.id);
      });

      // 添加当前页新选中的数据
      selection.forEach((row) => {
        if (!this.selectedRows.some((item) => item.id === row.id)) {
          this.selectedRows.push(row);
        }
      });

      // 更新选中的id数组
      this.ids = this.selectedRows.map((row) => row.id);
    },
    /** 国家平台同步状态展示 */
    ncnpStatusText(status) {
      if (status === 1) return "已同步";
      if (status === 2) return "同步失败";
      return "未同步";
    },
    ncnpClass(status) {
      if (status === 1) return "ncnp-sync-ok";
      if (status === 2) return "ncnp-sync-fail";
      return "ncnp-sync-pending";
    },
    /** 单条上报国家平台 */
    handleNcnpSync(row) {
      this.$confirm(`确认将「${row.goodsName}」同步到国家平台？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      })
        .then(() => {
          ncnpGoodsSync({ goodsId: row.id })
            .then((res) => {
              const data = res && res.data ? res.data : {};
              if (data.success) {
                this.$message.success("同步成功");
              } else {
                this.$message.error(data.message || "同步失败");
              }
              this.getList();
            })
            .catch(() => {
              this.$message.error("同步请求异常");
            });
        })
        .catch(() => {});
    },
    /** 批量重试失败/未同步商品 */
    handleNcnpRetryAll() {
      ncnpGoodsRetry()
        .then((res) => {
          const data = res && res.data ? res.data : {};
          this.$message.success(
            `重试完成：成功 ${(data.success_ids || []).length} / 失败 ${(data.failed_ids || []).length}`
          );
          this.getList();
        })
        .catch(() => {
          this.$message.error("批量重试失败");
        });
    },
    /** 修改状态操作 */
    handleStatusChange(row) {
      // TODO: 实现状态修改逻辑
      let goodsStatus = row.goodsStatus == 0 ? 1 : 0;

      this.$confirm(
        `确认${row.goodsStatus == 0 ? "上" : "下"}架选中的数据吗？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          // TODO: 调用批量上架接口
          goodsBatchStatus({ ids: row.id, goodsStatus }).then((res) => {
            if (res.code === 200) {
              this.$message.success("操作成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    /** 每页显示条数改变 */
    handleSizeChange(val) {
      this.queryParams.size = val;
      this.getList();
    },
    /** 当前页改变 */
    handleCurrentChange(val) {
      this.queryParams.current = val;
      this.getList();
    },
    /** 单个删除操作 */
    handleDelete(row) {
      if (row.goodsStatus == 1) {
        this.$message.warning("上架状态的产品不能删除，请先下架");
        return;
      }
      
      this.$confirm("确认删除该产品吗？此操作不可恢复", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        goodsRemove(row.id).then(res => {
          if (res.code === 200) {
            this.$message.success("删除成功");
            // 清空选中状态
            this.selectedRows = [];
            this.ids = [];
            if (this.$refs.table) {
              this.$refs.table.clearSelection();
            }
            this.getList();
          } 
        }).catch(() => {
          this.$message.error("删除失败");
        });
      }).catch(() => {
        // 用户取消删除
      });
    },
    
    /** 批量删除操作 */
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      
      // 检查是否有上架状态的数据
      const hasOnlineData = this.selectedRows.some(row => row.goodsStatus == 1);
      if (hasOnlineData) {
        this.$message.warning("选中的数据中包含已上架的数据，只能删除已下架的数据");
        return;
      }
      
      this.$confirm(`确认删除选中的 ${this.selectedRows.length} 条数据吗？此操作不可恢复`, "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const ids = this.selectedRows.map(row => row.id).join(",");
        goodsRemove(ids).then(res => {
          if (res.code === 200) {
            this.$message.success("批量删除成功");
            this.getList();
            this.selectedRows = [];
            this.ids = [];
          }
        }).catch(() => {
          this.$message.error("批量删除失败");
        });
      }).catch(() => {
        // 用户取消删除
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.resource-container {
  /* padding: 20px; */

  .search-wrapper,
  .operation-wrapper,
  .table-wrapper {
    margin-bottom: 10px;
  }

  .mb8 {
    margin-bottom: 8px;
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }

  .demo-form-inline {
    display: flex;
    flex-wrap: wrap;
  }

  .goodsStatus_1 {
    color: #67c23a;
  }
}
</style>
